export enum VideosRoutes {
  AddVersion = 'add-version',
  CopyMany = 'copy-many',
  CreateMany = 'create-many',
  CreateOne = 'create-one',
  DeleteMany = 'delete-many',
  ExportCsv = 'export-csv',
  ExtractFrames = 'extract-frames',
  GetPlayback = 'get-playback',
  GetVisible = 'get-visible',
  ImportCsv = 'import-csv',
  UpdateOne = 'update-one',
}
